import {ThemeOptions, radioClasses} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiRadio = ({radio, font, filterchip}: Tokens): ThemeOptions['components'] => ({
  MuiRadio: {
    defaultProps: {
      disableRipple: true,
      color: 'primary'
    },
    styleOverrides: {
      root: {
        color: radio?.primary.desktop.border.color,
        marginRight: 8,
        maxWidth: 24,
        maxHeight: 24,
        minWidth: 24,
        '&:hover': {
          backgroundColor: 'transparent'
        },
        '&.Mui-focusVisible, &:focus-within': {
          outline: 'none'
        },
        '&:active': {
          color: radio?.primary.desktop.active.border.color
        },
        [`&.${radioClasses.disabled}`]: {
          color: radio?.primary.desktop.disabled.border.color
        },

        // https://github.com/mui/material-ui/issues/10820
        '&.MuiRadioChip-root': {
          '&': {
            height: '1px',
            opacity: 0,
            position: 'absolute',
            width: '1px',
            /* Styles updated to use border and background tokens. */
            '& + .MuiFormControlLabel-label': {
              background: filterchip.selectable.desktop.background.color,
              border: `1px solid ${filterchip.selectable.desktop.border.color}`,
              borderRadius: '4px',
              color: filterchip.selectable.desktop.font.color,
              fontFamily: typeof font.family === 'string' ? font.family : font.family.sans,
              fontSize: '14.22px',
              fontWeight: 700,
              padding: '4px 10px',

              '&:hover': {
                backgroundColor: filterchip.selectable.desktop.hover.background.color,
                borderColor: filterchip.selectable.desktop.hover.border.color,
                color: filterchip.selectable.desktop.hover.font.color
              }
            }
          },

          [`&.${radioClasses.checked}`]: {
            borderRadius: 0,
            left: '5px',
            opacity: 1,

            '& .MuiSvgIcon-root': {
              color: filterchip.selectable.desktop.selected.icon.background.color, // '#FFF'
              width: '20px'
            },

            '& + .MuiFormControlLabel-label': {
              background: filterchip.selectable.desktop.selected.background.color,
              borderColor: filterchip.selectable.desktop.selected.border.color,
              color: filterchip.selectable.desktop.selected.font.color, // '#FFF'
              paddingLeft: '30px', // to accommodate custom selected icon

              '&:focus': {
                padding: '5px'
              },
              '&:hover': {
                backgroundColor: filterchip.selectable.desktop.hover.background.color,
                borderColor: filterchip.selectable.desktop.hover.border.color,
                color: filterchip.selectable.desktop.hover.font.color
              }
            }
          },

          '&.MuiRadioChip-small': {
            '& + .MuiFormControlLabel-label': {
              fontSize: '12.64px',
              padding: '3px 8px'
            },

            [`&.${radioClasses.checked}`]: {
              '& .MuiSvgIcon-root': {
                color: filterchip.selectable.desktop.selected.icon.background.color, // '#FFF'
                width: '15px'
              },

              '& + .MuiFormControlLabel-label': {
                paddingLeft: '28px' // to accommodate selected icon
              }
            }
          }
        }
      },

      /* Styles applied to the root element if `color="primary"`. */
      colorPrimary: {
        [`&.${radioClasses.checked}`]: {
          color: radio?.primary.desktop.selected.border.color,
          '&:hover': {
            // Removes MUI default
            backgroundColor: 'transparent',
            color: radio?.primary.desktop.selected.hover.border.color
          }
        },
        [`&.${radioClasses.disabled}`]: {
          color: radio?.primary.desktop.disabled.border.color
        }
      },

      /* Styles applied to the root element if `color="secondary"`. */
      colorSecondary: {
        [`&.${radioClasses.checked}`]: {
          color: radio?.primary.desktop.selected.border.color,
          '&:hover': {
            // Removes MUI default
            backgroundColor: 'transparent',
            color: radio?.primary.desktop.selected.hover.border.color
          }
        },
        [`&.${radioClasses.disabled}`]: {
          color: radio?.primary.desktop.disabled.border.color
        }
      }
    }
  }
});
